import { render } from "./PasswordUpdate.vue?vue&type=template&id=e476d41a&scoped=true"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"

import "./PasswordUpdate.vue?vue&type=style&index=0&id=e476d41a&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e476d41a"]])

export default __exports__